module.exports = __webpack_public_path__ + "img/ig.a3383e75.gif";